import { SignUpQuestionId } from '../../questionService/questionModules/signUpQuestionModules'
import { Question, QuestionType } from '../types'

// this should only own the visual presentation of each question eg the copy
// the logic should live in signUpQuestionModules
// todo: consider taking the types and option values out of here
export const signUpQuestions: { [key in SignUpQuestionId]: Question } = {
  [SignUpQuestionId.WHEN_TO_START]: {
    type: QuestionType.SINGLESELECT,
    label: 'When are you planning to start IVF?',
    options: [
      { name: 'In the next few months', value: 'FEW_MONTHS' },
      { name: 'In 6-12 months', value: 'SIX_TWELVE_MONTHS' },
      { name: "I'm not sure", value: 'NOT_SURE' },
    ],
  },
  [SignUpQuestionId.NEED_MORE_INFO_EARLY_STAGE]: {
    type: QuestionType.READONLY,
    options: null,
  },
  [SignUpQuestionId.NEED_MORE_INFO_LATE_STAGE]: {
    type: QuestionType.READONLY,
    options: null,
  },
  [SignUpQuestionId.FIRST_NAME]: {
    type: QuestionType.TEXT,
    label: 'First name',
    placeholder: 'First name',
    options: null,
  },
  [SignUpQuestionId.EMAIL]: {
    type: QuestionType.EMAIL,
    label: 'Your email',
    placeholder: 'Your email',
    subText:
      'We use this to send your pricing and plan details. We never share it.',
    options: null,
  },
  [SignUpQuestionId.EMAIL_CONSENT]: {
    type: QuestionType.CONSENTBOX,
    label:
      'I would like to receive emails relating to updates and products about Gaia',
    options: null,
  },
}
